import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pantry-list-show-view" }
const _hoisted_2 = { class: "pantry-list-view-top-view" }
const _hoisted_3 = { class: "pantry-list-view-list-view" }
const _hoisted_4 = { class: "pantry-list-view-header-area" }
const _hoisted_5 = { class: "pantry-list-view-sort-area" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pantry-list-view-sort-text" }, "表示順序：", -1)
const _hoisted_7 = { class: "pantry-list-view-dropdown-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryListItem = _resolveComponent("PantryListItem")
  const _component_PantryPullToRefresh = _resolveComponent("PantryPullToRefresh")
  const _component_PantryDropdownList = _resolveComponent("PantryDropdownList")
  const _component_PantryListEmptyView = _resolveComponent("PantryListEmptyView")

  return (_openBlock(), _createBlock("div", {
    class: "pantry-list-view",
    style: _ctx.styleBackground
  }, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_PantryPullToRefresh, {
            topMargin: 0,
            style: _ctx.styleTop,
            enabled: _ctx.isRefreshEnabled,
            topClass: 'pantry-list-view-scroll-area',
            onRefresh: _ctx.refresh
          }, {
            default: _withCtx(() => [
              _createVNode("div", {
                class: "pantry-list-view-scroll-area",
                onScrollPassive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScroll($event)))
              }, [
                _createVNode("div", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item) => {
                    return (_openBlock(), _createBlock(_component_PantryListItem, {
                      key: item.id,
                      data: item.data,
                      selectMode: _ctx.selectMode,
                      searchMode: _ctx.searchMode,
                      value: item.value,
                      onSelectCheck: _ctx.onSelectCheck,
                      onClickFood: _ctx.onClickFood,
                      onClickFavorite: _ctx.onClickFavorite,
                      onClickShoplist: _ctx.onClickShoplist,
                      onChangeValue: _ctx.changeValue
                    }, null, 8, ["data", "selectMode", "searchMode", "value", "onSelectCheck", "onClickFood", "onClickFavorite", "onClickShoplist", "onChangeValue"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _withDirectives(_createVNode("div", { style: _ctx.styleSearchModeView }, null, 4), [
                    [_vShow, _ctx.searchMode || _ctx.selectMode]
                  ])
                ])
              ], 32)
            ]),
            _: 1
          }, 8, ["style", "enabled", "onRefresh"])
        ]),
        _withDirectives(_createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_PantryDropdownList, {
                dropdownList: _ctx.sortDropdownList.list,
                selectType: _ctx.sortType,
                onSelectItem: _ctx.selectSort
              }, null, 8, ["dropdownList", "selectType", "onSelectItem"])
            ])
          ]),
          _createVNode("div", {
            class: "pantry-list-view-select-text",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSelectMode(...args)))
          }, _toDisplayString(_ctx.getSelectMode()), 1)
        ], 512), [
          [_vShow, !_ctx.searchMode]
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isShow]
    ]),
    _withDirectives(_createVNode(_component_PantryPullToRefresh, {
      topMargin: 4.4,
      onRefresh: _ctx.refresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PantryListEmptyView)
      ]),
      _: 1
    }, 8, ["topMargin", "onRefresh"]), [
      [_vShow, !_ctx.isShow]
    ])
  ], 4))
}